import React from "react";
import { Checkbox, Switch } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";
import { call } from "../Helpers/Nodes";
import IconPicker from "../Shared/IconPicker/IconPicker";
import EditorActions from "../Shared/Edit/EditorActions";
import Scrollable from "../Shared/Edit/Scrollable";
import ErrorMessage from "../Shared/Error/ErrorMessage";
import pluralize from "pluralize";
import { updateEntityAndConfiguration } from "../../API/Entity/Entity";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { ENTITY_LABEL } from "../Helpers/Labels/EntityLabel";
import { isLibraryOrganization } from "../Helpers/Organization/Organization";
import { removeSpecialCharacters } from "./utils";
import { withTranslation } from 'react-i18next';
import { getAttributes, toggleAttributeRequiredInAlice, updateAllAttributeFormulaOnEntityNameChange } from "../../API/Attribute/Attribute";
import GenericTranslationDialog from "./GenericTranslationDialog";
import LifecycleRulesDialog from "./LifecycleRulesDialog";
import { getProjectRoles } from "../../API/Role/Role";
class EntityPropertyPanel extends React.Component {
    AllowedLimit = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
    countries = [
        ".jpg",
        ".jpeg",
        ".png",
        ".bmp",
        ".gif",
        ".txt",
        ".pdf",
        ".doc",
        ".docx",
        ".ppt",
        ".pptx",
        ".xls",
        ".xlsx",
        ".csv",
        ".mp3",
        ".m4a",
        ".wav",
        ".mp4",
        ".m4v",
        ".mpg",
        ".mpeg",
        ".wmv",
        ".mov",
        ".avi",
        ".swf",
        ".xml",
        ".zip",
        ".html",
        ".json",
    ];
    defaultData;
    isAccessedInLibrary = isLibraryOrganization(this.props.organizationName);
    isUserProfileEntity = false;
    t = this.props.t;
    i18n = this.props.i18n;

    constructor(props) {
        super(props);

        this.state = {
            _id: "",
            name: "",
            label: "",
            pluralLabel: "",
            description: "",
            Icon: "",
            allowAttachement: true,
            allowMultiple: true,
            allowSize: this.AllowedLimit[0],
            allowTypes: [],
            disabled: true,
            showAdditionalFields: false,
            tooltip: "",
            nameError: {
                isValid: true,
                message: ""
            },
            labelError: {
                isValid: true,
                message: ""
            },
            pluralLabelError: {
                isValid: true,
                message: ""
            },
            descriptionError: {
                isValid: true,
                message: ""
            },
            showTooltip: false,
            tooltipAnchor: {},
            data: this.countries.slice(),
            loading: false,
            showLabelTranslationDialog: false,
            languages: {},
            setLifecycleRules: false,
            lifecycleRules: [],
            completeStateId: "",
            overrideRoleIds: [],
            overrideReasons: [],
            lifecycleStates: [],
            lifecycleStateAttributeName: "",
            lifecycleRoles: [],
            showLifecycleRulesDialog: false
        };
        this.tooltipAnchor = React.createRef();
    }

    componentDidUpdate = (props, state) => {
        if (props.entityProperties._id !== this.props.entityProperties._id) {
            this.isUserProfileEntity = this.props.entityProperties.isUserEntity;
            var AllowTypes =
                this.props.entityProperties.allowTypes === undefined
                    ? []
                    : this.props.entityProperties.allowTypes.split(",");
            const showAdditionalFields = this.getShowMoreValueById(
                this.props.entityProperties._id
            );
            let data = {
                name: this.props.entityProperties.name,
                label: this.props.entityProperties.label,
                description: this.props.entityProperties.description,
                Icon: this.props.entityProperties.Icon,
                pluralLabel: this.props.entityProperties.pluralLabel,
                _id: this.props.entityProperties._id,
                tooltip: this.props.entityProperties.tooltip,
                allowAttachement: this.props.entityProperties.allowAttachement === true ? true : false,
                allowMultiple: this.props.entityProperties.allowMultiple === true ? true : false,
                allowSize: this.props.entityProperties.allowSize,
                allowTypes: AllowTypes,
                allowedTypesString: this.props.entityProperties.allowTypes,
                alwaysRecommended: this.props.entityProperties.alwaysRecommended === "true",
                requiredInAlice: this.props.entityProperties.requiredInAlice === "true",
                disabled: true,
                nameError: {
                    isValid: true,
                    message: ""
                },
                labelError: {
                    isValid: true,
                    message: ""
                },
                pluralLabelError: {
                    isValid: true,
                    message: ""
                },
                descriptionError: {
                    isValid: true,
                    message: ""
                },
                languages: this.props.entityProperties.languages,
                showAdditionalFields,
                setLifecycleRules: this.props.entityProperties.setLifecycleRules === true,
                lifecycleRules: this.props.entityProperties.lifecycleRules || [],
                completeStateId: this.props.entityProperties.completeStateId || "",
                overrideRoleIds: this.props.entityProperties.overrideRoleIds || [],
                overrideReasons: this.props.entityProperties.overrideReasons || []
            };
            this.defaultData = data;
            this.setState(data, () => {
                this.loadLifecycleMetadata(this.props.entityProperties._id);
            });
        }

        if (this.state.disabled !== state.disabled && this.props.mutators) {
            this.props.mutators.setFormsWithChanges(prevValue => ({
                ...prevValue,
                entityForm: !this.state.disabled
            }))
        }
    }

    componentDidMount = () => {
        this.isUserProfileEntity = this.props.entityProperties.isUserEntity;
        var AllowTypes = this.props.entityProperties.allowTypes === undefined ? [] : this.props.entityProperties.allowTypes.split(",");
        const showAdditionalFields = this.getShowMoreValueById(this.props.entityProperties._id);
        let data = {
            name: this.props.entityProperties.name,
            label: this.props.entityProperties.label,
            description: this.props.entityProperties.description,
            Icon: this.props.entityProperties.Icon,
            pluralLabel: this.props.entityProperties.pluralLabel,
            // inherits: this.props.EntityData.find(x => x.name === this.props.entityProperties.inherits) || this.props.entityProperties.inherits,
            _id: this.props.entityProperties._id,
            tooltip: this.props.entityProperties.tooltip,
            allowAttachement: this.props.entityProperties.allowAttachement === true ? true : false,
            allowMultiple: this.props.entityProperties.allowMultiple === true ? true : false,
            allowSize: this.props.entityProperties.allowSize,
            alwaysRecommended: this.props.entityProperties.alwaysRecommended === "true",
            requiredInAlice: this.props.entityProperties.requiredInAlice === "true",
            allowTypes: AllowTypes,
            disabled: true,
            allowedTypesString: this.props.entityProperties.allowTypes,
            showAdditionalFields,
            nameError: {
                isValid: true,
                message: ""
            },
            labelError: {
                isValid: true,
                message: ""
            },
            pluralLabelError: {
                isValid: true,
                message: ""
            },
            descriptionError: {
                isValid: true,
                message: ""
            },
            languages: this.props.entityProperties.languages,
            setLifecycleRules: this.props.entityProperties.setLifecycleRules === true,
            lifecycleRules: this.props.entityProperties.lifecycleRules || [],
            completeStateId: this.props.entityProperties.completeStateId || "",
            overrideRoleIds: this.props.entityProperties.overrideRoleIds || [],
            overrideReasons: this.props.entityProperties.overrideReasons || []
        };
        if (this.props.mutators) {
            this.props.mutators.setFormSaveFunction(() => this.update);
        }
        this.defaultData = data;
        this.setState(data, () => {
            this.loadLifecycleMetadata(this.props.entityProperties._id);
        });
    }

    getShowMoreValueById = (_id) => {
        const entityConfigLocalStorageString = localStorage.getItem("entity-config");
        if (entityConfigLocalStorageString === null) {
            return false;
        }
        const entityConfig = JSON.parse(entityConfigLocalStorageString);
        if (entityConfig[_id] === undefined) {
            return false;
        }
        return entityConfig[_id]["showMoreEntityProperties"];
    }

    getLifecycleStatesFromAttributes = (attributes = []) => {
        const normalizedAttributes = Array.isArray(attributes)
            ? attributes
            : (Array.isArray(attributes?.data) ? attributes.data : []);
        const stateAttribute = normalizedAttributes.find(attribute => (
            attribute?.attributeType === "State Field" ||
            attribute?.lookupType === "State Field"
        ));
        if (!stateAttribute) {
            return {
                states: [],
                stateAttributeName: ""
            };
        }

        let rawStates = stateAttribute.statefield;
        if (!rawStates && typeof stateAttribute.picklist === "string") {
            rawStates = stateAttribute.picklist.split("ɖ");
        }
        if (!Array.isArray(rawStates)) {
            return {
                states: [],
                stateAttributeName: stateAttribute.attributeName || stateAttribute.name || "State"
            };
        }

        const states = rawStates
            .map((state, index) => {
                if (typeof state === "string") {
                    const name = state.trim();
                    if (!name) {
                        return null;
                    }
                    return {
                        _id: name,
                        name
                    };
                }
                const name = (state?.name || state?.key || state?.value || "").trim();
                if (!name) {
                    return null;
                }
                const stateId = state?._id || state?.id || state?.key || name;
                return {
                    _id: stateId,
                    name
                };
            })
            .filter(Boolean)
            .filter((state, index, self) => self.findIndex(item => item._id === state._id) === index);
        return {
            states,
            stateAttributeName: stateAttribute.attributeName || stateAttribute.name || "State"
        };
    }

    normalizeRoles = (rolesPayload) => {
        const rolesArray = Array.isArray(rolesPayload)
            ? rolesPayload
            : (Array.isArray(rolesPayload?.data) ? rolesPayload.data : []);
        return rolesArray
            .filter(role => role && role._id)
            .map(role => ({
                ...role,
                roleName: role.roleName || role.name || role.title || ""
            }))
            .filter(role => role.roleName);
    }

    reconcileLifecycleConfiguration = (config, states) => {
        const stateMap = new Map((states || []).map(state => [state._id, state.name]));
        const lifecycleRules = (config.lifecycleRules || []).filter(rule => {
            if (!rule || !rule.stateId) {
                return false;
            }
            const currentStateName = stateMap.get(rule.stateId);
            if (!currentStateName) {
                return false;
            }
            if (rule.stateName && rule.stateName !== currentStateName) {
                return false;
            }
            return true;
        }).map((rule, index) => ({
            _id: rule._id,
            stateId: rule.stateId,
            stateName: stateMap.get(rule.stateId) || "",
            operation: rule.operation,
            roleIds: rule.roleIds || [],
            order: parseInt((index + 1) * 10000000000, 10)
        }));

        return {
            lifecycleRules,
            completeStateId: stateMap.has(config.completeStateId) ? config.completeStateId : "",
            overrideRoleIds: config.overrideRoleIds || [],
            overrideReasons: (config.overrideReasons || []).filter(reason => reason && reason.trim().length > 0).map(reason => reason.trim())
        };
    }

    loadLifecycleMetadata = async (entityId) => {
        if (!entityId) {
            return;
        }
        try {
            const [attributes, roles] = await Promise.all([
                getAttributes(entityId),
                getProjectRoles(this.props.project._id)
            ]);
            const lifecycleStateData = this.getLifecycleStatesFromAttributes(attributes);
            const lifecycleStates = lifecycleStateData.states || [];
            let lifecycleRoles = this.normalizeRoles(roles);
            if (lifecycleRoles.length === 0) {
                lifecycleRoles = this.normalizeRoles(this.props.project?.roles);
            }
            const reconciled = this.reconcileLifecycleConfiguration({
                lifecycleRules: this.state.lifecycleRules,
                completeStateId: this.state.completeStateId,
                overrideRoleIds: this.state.overrideRoleIds,
                overrideReasons: this.state.overrideReasons
            }, lifecycleStates);
            this.setState({
                lifecycleStates,
                lifecycleStateAttributeName: lifecycleStateData.stateAttributeName || "",
                lifecycleRoles,
                lifecycleRules: reconciled.lifecycleRules,
                completeStateId: reconciled.completeStateId,
                overrideRoleIds: reconciled.overrideRoleIds,
                overrideReasons: reconciled.overrideReasons
            }, () => {
                this.setDisabled();
            });
        } catch (error) {
            console.error(error);
        }
    }

    setDisabled = () => {
        if (
            !this.state.labelError.isValid ||
            !this.state.descriptionError.isValid ||
            !this.state.pluralLabelError.isValid ||
            this.state.name.trim().match(/^\d/) ||
            !this.state.nameError.isValid
        ) {
            this.setState({ disabled: true });
            return;
        }
        const hasInvalidLifecycleRules = this.state.setLifecycleRules && this.state.lifecycleRules.some(rule => {
            return !rule.stateId || !rule.operation || !rule.roleIds || rule.roleIds.length === 0;
        });
        if (hasInvalidLifecycleRules) {
            this.setState({ disabled: true });
            return;
        }
        const isLangauagesChanged = this.isLanguagesTraslationChanged();
        const normalizedLifecycleRules = (this.state.lifecycleRules || []).map(rule => ({
            stateId: rule.stateId || "",
            operation: rule.operation || "",
            roleIds: [...(rule.roleIds || [])].sort()
        }));
        const normalizedDefaultLifecycleRules = (this.defaultData.lifecycleRules || []).map(rule => ({
            stateId: rule.stateId || "",
            operation: rule.operation || "",
            roleIds: [...(rule.roleIds || [])].sort()
        }));
        const areOverrideRolesChanged = [...(this.state.overrideRoleIds || [])].sort().join(",") !== [...(this.defaultData.overrideRoleIds || [])].sort().join(",");
        const normalizeReasons = (reasons = []) => reasons.map(reason => reason.trim()).filter(Boolean);
        const areOverrideReasonsChanged = JSON.stringify(normalizeReasons(this.state.overrideReasons)) !== JSON.stringify(normalizeReasons(this.defaultData.overrideReasons || []));
        if (
            this.defaultData.name !== this.state.name ||
            this.defaultData.label !== this.state.label ||
            this.defaultData.description !== this.state.description ||
            this.defaultData.Icon !== this.state.Icon ||
            this.defaultData.pluralLabel !== this.state.pluralLabel ||
            this.defaultData.allowAttachement !== this.state.allowAttachement ||
            this.defaultData.setLifecycleRules !== this.state.setLifecycleRules ||
            JSON.stringify(normalizedLifecycleRules) !== JSON.stringify(normalizedDefaultLifecycleRules) ||
            (this.state.completeStateId || "") !== (this.defaultData.completeStateId || "") ||
            areOverrideRolesChanged ||
            areOverrideReasonsChanged ||
            isLangauagesChanged ||
            (
                this.isAccessedInLibrary &&
                this.props.isInternalUser &&
                (
                    this.state.alwaysRecommended !== this.defaultData.alwaysRecommended ||
                    this.state.requiredInAlice !== this.defaultData.requiredInAlice
                )
            )
        ) {
            this.setState({ disabled: false });
        } else {
            this.setState({ disabled: true });
        }
    };

    isLanguagesTraslationChanged = () => {
        let isChanged = false;
        for (let key in this.state.languages) {
            if (
                this.state.languages[key].label !== this.defaultData.languages[key].label ||
                this.state.languages[key].pluralLabel !== this.defaultData.languages[key].pluralLabel
            ) {
                isChanged = true;
                break;
            }
        }
        return isChanged;
    }

    setNameValue = (e) => {
        let { nameError } = this.state;
        let entityName = e.target.value.trim()
        if (entityName === "") {
            nameError.isValid = false
            nameError.message = this.t("entity.property_panel.errors.name_required")
        } else if (entityName.match(/^\d/)) {
            nameError.isValid = false
            nameError.message = this.t("entity.property_panel.errors.name_can_not_start_with_number")
        } else if (entityName.trim().length > 30) {
            nameError.isValid = false
            nameError.message = this.t("entity.property_panel.errors.name_length_exceeded")
        } else {
            let isNameValueExit = this.props.EntityData.find((x) => (
                removeSpecialCharacters(x.name.trim().toLowerCase()) ===
                removeSpecialCharacters(entityName.toLowerCase())
            ))
            let exist = isNameValueExit === undefined ? "" : isNameValueExit.name;
            if (exist !== "" && exist !== this.defaultData.name) {
                nameError.isValid = false
                nameError.message = this.t("entity.property_panel.errors.name_exists")
            } else {
                nameError.isValid = true
                nameError.message = ""
            }
        }
        this.setState({
            name: e.target.value,
            nameError: nameError,
        }, () => {
            this.setDisabled();
        });
    }

    setLabelValue = (e) => {
        let { labelError } = this.state;
        if (e.target.value.trim() === "") {
            labelError.isValid = false
            labelError.message = this.t("entity.property_panel.errors.label_required")
        } else {
            labelError.isValid = true
            labelError.message = ""
        }
        this.setState({
            labelError: labelError,
            label: e.target.value,
        }, () => {
            this.setDisabled();
        });
    }

    setLabelTranslation = (data) => {
        this.setState({
            showLabelTranslationDialog: false,
            languages: data
        }, () => {
            this.setDisabled();
        });
    }

    setPluralLabelValue = (e) => {
        let { pluralLabelError } = this.state
        if (e.target.value.trim() === "") {
            pluralLabelError.isValid = false
            pluralLabelError.message = this.t("entity.property_panel.errors.plural_label_required")
        } else {
            pluralLabelError.isValid = true
            pluralLabelError.message = ""
        }
        this.setState({
            pluralLabel: e.target.value,
        }, () => {
            this.setDisabled();
        });
    };

    setDescriptionValue = (e) => {
        this.setState(
            {
                description: e.target.value
            },
            () => {
                this.setDisabled();
            }
        );
    };

    setAllowAttachment = (e) => {
        this.setState({
            allowAttachement: e.value,
            allowSize: this.AllowedLimit[0],
            allowMultiple: e.value,
        }, () => {
            this.setDisabled();
        })
    };

    handleAllowMultiple = (e) => {
        this.setState(
            {
                allowMultiple: e.value,
            },
            () => {
                this.setDisabled();
            }
        );
    };

    handleAllowSize = (e) => {
        this.setState(
            {
                allowSize: e.target.value,
            },
            () => {
                this.setDisabled();
            }
        );
    };

    filterChange = (event) => {
        const filter = event.filter;
        const allData = this.countries.slice();
        const newData =
            filter.value.length > 3 ? filterBy(allData, filter) : allData;
        this.setState({
            data: newData,
        });
    };

    handleAttachmentTypes = (e) => {
        const values = e.target.value;
        const lastItem = values[values.length - 1];

        if (lastItem) {
            values.pop();
            const sameItem = values.find((value) => value === lastItem);
            if (sameItem === undefined && lastItem.length <= 60) {
                values.push(lastItem);
            }
            if (lastItem.length > 60) {
                this.setState({ showTagError: true });
            } else {
                this.setState({ showTagError: false });
            }
        }

        this.setState(
            {
                allowTypes: values,
            },
            () => {
                this.setDisabled();
            }
        );
    };

    setIcon = (props, value) => {
        this.setState(
            {
                Icon: props,
            },
            () => {
                this.setDisabled();
            }
        );
    };

    setTooltip = (e) => {
        this.setState({ tooltip: e.target.value }, () => {
            this.setDisabled();
        });
    };

    getDisabled = () => {
        return this.state.disabled;
    };

    hasCharacterSpecial(str) {
        const regex = /[0-9!@#$%^&*(),.?":{}|<>]/;
        return regex.test(str);
    }

    handleRecommendationPropertyChange = (e) => {
        const { name } = e.target;
        const { value } = e;
        this.setState({
            [name]: value,
        }, () => {
            this.setDisabled();
        });
    };

    handleLifecycleRulesToggle = (e) => {
        const setLifecycleRules = e.value;
        this.setState({
            setLifecycleRules,
            ...(setLifecycleRules === false && {
                lifecycleRules: [],
                completeStateId: "",
                overrideRoleIds: [],
                overrideReasons: []
            })
        }, () => {
            this.setDisabled();
        });
    };

    toggleLifecycleRulesDialog = () => {
        const shouldOpen = !this.state.showLifecycleRulesDialog;
        if (!shouldOpen) {
            this.setState({ showLifecycleRulesDialog: false });
            return;
        }
        const reconciled = this.reconcileLifecycleConfiguration({
            lifecycleRules: this.state.lifecycleRules,
            completeStateId: this.state.completeStateId,
            overrideRoleIds: this.state.overrideRoleIds,
            overrideReasons: this.state.overrideReasons
        }, this.state.lifecycleStates);
        this.setState({
            showLifecycleRulesDialog: true,
            lifecycleRules: reconciled.lifecycleRules,
            completeStateId: reconciled.completeStateId,
            overrideRoleIds: reconciled.overrideRoleIds,
            overrideReasons: reconciled.overrideReasons
        }, () => {
            this.setDisabled();
        });
    };

    saveLifecycleRules = (data) => {
        this.setState({
            lifecycleRules: data.lifecycleRules,
            completeStateId: data.completeStateId,
            overrideRoleIds: data.overrideRoleIds,
            overrideReasons: data.overrideReasons,
            showLifecycleRulesDialog: false
        }, () => {
            this.setDisabled();
        });
    };

    update = async (e, callback = undefined) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        try {
            this.setState({
                disabled: true,
                loading: true
            })
            let id = this.state._id;
            var AllowTypes = "";
            this.state.allowTypes.forEach((element) => { AllowTypes = AllowTypes + "," + element });

            AllowTypes = AllowTypes.substr(1);
            if (this.defaultData.allowAttachement && !this.state.allowAttachement) {
                call("removeAttachment", "POST").with({ id: id });
            }
            const entityNameChanged = this.defaultData.name !== this.state.name;
            const labelChanged = this.defaultData.label !== this.state.label;
            const pluralLabelChanged = this.defaultData.pluralLabel !== this.state.pluralLabel;

            let label = this.state.label.trim();
            let pluralLabel = this.state.pluralLabel;
            if (!labelChanged && entityNameChanged) {
                label = this.state.name.trim();
            }
            if (!pluralLabelChanged) {
                if (this.hasCharacterSpecial(label)) {
                    pluralLabel = label
                } else {
                    pluralLabel = pluralize(label);
                }
            }
            const reconciledLifecycleConfig = this.state.setLifecycleRules
                ? this.reconcileLifecycleConfiguration({
                    lifecycleRules: this.state.lifecycleRules,
                    completeStateId: this.state.completeStateId,
                    overrideRoleIds: this.state.overrideRoleIds,
                    overrideReasons: this.state.overrideReasons
                }, this.state.lifecycleStates)
                : {
                    lifecycleRules: [],
                    completeStateId: "",
                    overrideRoleIds: [],
                    overrideReasons: []
                };
            const updateEntityResponse = await updateEntityAndConfiguration(id, {
                name: this.state.name.trim(),
                allowAttachement: this.state.allowAttachement,
                projectId: this.props.project._id,
                allowMultiple: this.state.allowMultiple,
                allowSize: this.state.allowSize,
                pluralLabel: pluralLabel.trim(),
                allowTypes: AllowTypes,
                label: label.trim(),
                description: this.state.description.trim(),
                Icon: this.state.Icon,
                tooltip: this.state.tooltip,
                alwaysRecommended: this.state.alwaysRecommended,
                requiredInAlice: this.state.requiredInAlice,
                languages: this.state.languages,
                setLifecycleRules: this.state.setLifecycleRules,
                lifecycleRules: reconciledLifecycleConfig.lifecycleRules,
                completeStateId: reconciledLifecycleConfig.completeStateId,
                overrideRoleIds: reconciledLifecycleConfig.overrideRoleIds,
                overrideReasons: reconciledLifecycleConfig.overrideReasons
            });
            if (
                this.state.requiredInAlice === false &&
                this.defaultData.requiredInAlice === true
            ) {
                await toggleAttributeRequiredInAlice(id)
            }

            // to be done once attribute is implemented
            if (this.state.name !== this.props.entityProperties.name) {
                await this.updateAllFormulaByEntityChange();
            }

            var allowTypes = updateEntityResponse.data.entity.allowTypes === undefined
                ? []
                : updateEntityResponse.data.entity.allowTypes.split(",");
            let data = {
                name: updateEntityResponse.data.entity.name,
                label: updateEntityResponse.data.entity.label,
                description: updateEntityResponse.data.entity.description,
                Icon: updateEntityResponse.data.entity.Icon,
                pluralLabel: updateEntityResponse.data.entity.pluralLabel,
                _id: updateEntityResponse.data.entity._id,
                tooltip: updateEntityResponse.data.entity.tooltip,
                allowAttachement: updateEntityResponse.data.entity.allowAttachement === true ? true : false,
                allowMultiple: updateEntityResponse.data.entity.allowMultiple === true ? true : false,
                allowSize: updateEntityResponse.data.entity.allowSize,
                allowTypes: allowTypes,
                disabled: true,
                allowedTypesString: updateEntityResponse.data.entity.allowTypes,
                showAdditionalFields: this.state.showMoreEntityProperties,
                alwaysRecommended: updateEntityResponse.data.entity.alwaysRecommended,
                requiredInAlice: updateEntityResponse.data.entity.requiredInAlice,
                languages: updateEntityResponse.data.entity.languages,
                setLifecycleRules: updateEntityResponse.data.entity.setLifecycleRules === true,
                lifecycleRules: updateEntityResponse.data.entity.lifecycleRules || [],
                completeStateId: updateEntityResponse.data.entity.completeStateId || "",
                overrideRoleIds: updateEntityResponse.data.entity.overrideRoleIds || [],
                overrideReasons: updateEntityResponse.data.entity.overrideReasons || []
            };
            this.defaultData = data;
            this.setState(data);
            this.props.entityStateUpdater(id, updateEntityResponse.data.entity);
            this.setState({ loading: false })
            if (callback !== undefined) {
                callback();
            }
        } catch (e) {
            console.error(e);
        } finally {
            if (this.props.mutators && this.props.mutators.setFormsWithChanges) {
                this.props.mutators.setFormsWithChanges(prevValue => ({
                    ...prevValue,
                    entityForm: false
                }));
            }
        }
    }

    updateAllFormulaByEntityChange = async () => {
        const response = await updateAllAttributeFormulaOnEntityNameChange({
            entityId: this.state._id,
            oldEntityName: this.props.entityProperties.name,
            newEntityName: this.state.name
        })
        this.setState({
            referenceAttr: Array.from(new Set(response.message)),
            referenceChecked: true
        });
    }

    setDefault = () => {
        this.setState({
            ...this.defaultData,
            nameError: {
                isValid: true,
                message: ""
            },
            labelError: {
                isValid: true,
                message: ""
            },
            pluralLabelError: {
                isValid: true,
                message: ""
            },
            descriptionError: {
                isValid: true,
                message: ""
            },
            disabled: true
        })
    };

    toggleFields = () => {
        this.syncChangeToLocalStorage(!this.state.showAdditionalFields);
        this.setState({
            showAdditionalFields: !this.state.showAdditionalFields,
        });
    };

    syncChangeToLocalStorage = (value) => {
        const { _id } = this.props.entityProperties;
        const entityConfigLocalStorageString =
            localStorage.getItem("entity-config");
        const entityConfig =
            entityConfigLocalStorageString === null
                ? {}
                : JSON.parse(entityConfigLocalStorageString);
        if (entityConfig[_id] === undefined) {
            entityConfig[_id] = {};
        }
        entityConfig[_id]["showMoreEntityProperties"] = value;
        localStorage.setItem("entity-config", JSON.stringify(entityConfig));
    };

    handleTooltip = (e) => {
        this.setState({
            showTooltip: !this.state.showTooltip,
            tooltipAnchor: e.target,
        });
    };

    hasErrors = (e) => {
        let errors = !this.state.disabled
        if (
            this.state.nameError.isValid === false ||
            this.state.labelError.isValid === false ||
            this.state.descriptionError.isValid === false ||
            this.state.pluralLabelError.isValid === false
        ) {
            errors = true
        }
        return errors
    }

    render() {
        return (
            <div className="h-100">
                {
                    this.state.loading &&
                    <OverlayLoader />
                }
                <div className="d-flex flex-column h-100" >
                    <div>
                        <EditorActions
                            header={this.t("entity.property_panel.header.title")}
                            value={this.state.name}
                            valuePlaceholder={""}
                            valueChanged={this.setNameValue}
                            redoClicked={this.setDefault}
                            saveClicked={this.update}
                            active={this.state.disabled}
                            hasErrors={this.hasErrors()}
                            deleteDisabled={this.isUserProfileEntity}
                            deleteClicked={() => { this.props.Delete(this.props.entityProperties._id); }}
                            ShowMoreButtons={false}
                            saving={this.state.loading}
                        />
                    </div>
                    <Scrollable>
                        <>
                            <div className="form-label d-inline-block" required>
                                {this.t("entity.property_panel.form.name_label")}
                            </div>
                            <ErrorMessage valid={this.state.nameError.isValid} error={this.state.nameError.message} />
                            <input
                                className={"form-control name-text"}
                                value={this.state.name}
                                onChange={this.setNameValue}
                                maxLength={64}
                                disabled={this.isUserProfileEntity}
                            />
                            <Tooltip anchorElement="target" position="right" tooltipClassName="kendo-tool-tip">
                                <div
                                    className="form-label d-inline-block me-1"
                                    title={`
                                        Singular ${ENTITY_LABEL} name displayed in your application, like account, task
                                    `}
                                    required>
                                    {this.t("entity.property_panel.form.label_label")}
                                </div>
                                <ErrorMessage
                                    valid={this.state.labelError.isValid}
                                    error={this.state.labelError.message} />
                            </Tooltip>

                            <input
                                required={true}
                                type="text"
                                name="Enter Label"
                                className="py-2 form-control"
                                onChange={this.setLabelValue}
                                value={this.state.label}
                                maxLength={64}
                            />
                            {this.props.subscription.numOfLanguages > 1 &&
                                <Tooltip anchorElement="target" position="right" tooltipClassName="kendo-tool-tip">
                                    <div
                                        onClick={(e) => this.setState({
                                            showLabelTranslationDialog: true
                                        })}
                                        className="form-label d-inline-block cursor-pointer"
                                        title={`Multiple languages ${ENTITY_LABEL} label displayed in your application`}>
                                        <span className="text-primary">
                                            {this.t("entity.property_panel.form.label_translation_label")}
                                        </span>
                                    </div>
                                </Tooltip>
                            }
                            {
                                this.state.showLabelTranslationDialog &&
                                <GenericTranslationDialog
                                    onClose={() => this.setState({
                                        showLabelTranslationDialog: false
                                    })}
                                    onSave={this.setLabelTranslation}
                                    languages={this.state.languages}
                                    project={this.props.project}
                                    fields={["label", "pluralLabel"]}
                                    type={this.t("entity.property_panel.header.title").slice(0, -1)}
                                />
                            }
                            <Tooltip anchorElement="target" position="right" tooltipClassName="kendo-tool-tip">
                                <div
                                    className="form-label d-inline-block"
                                    title={`Icon of ${ENTITY_LABEL} displayed in your application`}>
                                    {this.t("entity.property_panel.form.icon_label")}
                                </div>
                            </Tooltip>

                            <IconPicker
                                onChange={this.setIcon}
                                selected={this.state.Icon}
                            />

                            <div className="form-label d-inline-block me-1">
                                {this.t("entity.property_panel.form.description_label")}
                            </div>
                            <ErrorMessage
                                valid={this.state.descriptionError.isValid}
                                error={this.state.descriptionError.message} />
                            <textarea
                                className="w-100 form-control"
                                value={this.state.description}
                                disabled={this.state.disableFields}
                                onChange={this.setDescriptionValue}
                            ></textarea>
                            {/* <div className="my-2">
                                <Checkbox
                                    checked={this.state.allowAttachement}
                                    label="Allow Attachment"
                                    onChange={this.setAllowAttachment}
                                />
                            </div> */}

                            {/* {this.state.showAdditionalFields && ( */}
                            <div className="row">
                                <div className="mb-2">
                                    <Tooltip anchorElement="target" position="right" tooltipClassName="kendo-tool-tip">
                                        <div
                                            className="form-label d-inline-block me-1"
                                            title={`
                                                ${ENTITY_LABEL} name displayed in your application when  multiple records are shown, like accounts, tasks
                                                `} required>
                                            {this.t("entity.property_panel.form.plural_label_label")}
                                        </div>
                                        <ErrorMessage
                                            valid={this.state.pluralLabelError.isValid}
                                            error={this.state.pluralLabelError.message} />
                                    </Tooltip>

                                    <input
                                        required={true}
                                        type="text"
                                        className="form-control"
                                        onChange={this.setPluralLabelValue}
                                        value={this.state.pluralLabel}
                                    />
                                </div>
                            </div>
                            <div className="mb-3">
                                <div className="form-label pt-2">{this.t("entity.property_panel.lifecycle_rules.toggle_label")}</div>
                                <Switch
                                    name="setLifecycleRules"
                                    defaultChecked={false}
                                    onChange={this.handleLifecycleRulesToggle}
                                    checked={this.state.setLifecycleRules}
                                />
                                {
                                    this.state.setLifecycleRules &&
                                    <div>
                                        <button
                                            type="button"
                                            className="btn p-2 hover-bg-7 hover-border-0 focus-border-0 form-label t-primary pointer"
                                            onClick={this.toggleLifecycleRulesDialog}
                                        >
                                            <i className="me-1 fa fa-edit"></i>
                                            {this.t("entity.property_panel.lifecycle_rules.edit_button")}
                                        </button>
                                    </div>
                                }
                                {
                                    this.state.showLifecycleRulesDialog &&
                                    <LifecycleRulesDialog
                                        onClose={this.toggleLifecycleRulesDialog}
                                        onSave={this.saveLifecycleRules}
                                        states={this.state.lifecycleStates}
                                        stateAttributeName={this.state.lifecycleStateAttributeName}
                                        roles={this.state.lifecycleRoles}
                                        lifecycleRules={this.state.lifecycleRules}
                                        completeStateId={this.state.completeStateId}
                                        overrideRoleIds={this.state.overrideRoleIds}
                                        overrideReasons={this.state.overrideReasons}
                                    />
                                }
                            </div>

                            {
                                this.isAccessedInLibrary &&
                                this.props.isInternalUser &&
                                <div className="row">
                                    <div className="col-12">
                                        <Checkbox
                                            label={"Always recommend in Alice"}
                                            name="alwaysRecommended"
                                            checked={this.state.alwaysRecommended}
                                            value={this.state.alwaysRecommended}
                                            onChange={this.handleRecommendationPropertyChange} />
                                    </div>
                                    <div className="col-12">
                                        <Checkbox
                                            label={"Required in Alice"}
                                            name="requiredInAlice"
                                            checked={this.state.requiredInAlice}
                                            value={this.state.requiredInAlice}
                                            onChange={this.handleRecommendationPropertyChange} />
                                    </div>
                                </div>
                            }
                            {/* )}
                            <ShowMore
                                className="my-3"
                                key={this.props.entityProperties.id}
                                more={this.state.showAdditionalFields}
                                toggled={(o) => this.toggleFields(o)}
                            ></ShowMore> */}
                        </>
                    </Scrollable>
                </div>
            </div>
        );
    }
}

export default withTranslation()(EntityPropertyPanel);
